import { Box, Typography, Container, Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import BottomNavigation from '../BottomNavigation/BottomNavigation';
import config from '../../Config';

export default function TopPicksScreen() {
  const navigate = useNavigate();
  const [topPicks, setTopPicks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopPicks = async () => {
      setLoading(true);

      try {
        const storedBookings = sessionStorage.getItem('userBookings');
        const currentIndex = Number(sessionStorage.getItem('currentBookingIndex')) || 0;

        let propertyDocumentID = null;

        if (storedBookings) {
          const bookings = JSON.parse(storedBookings);
          if (bookings.length > 0 && bookings[currentIndex]?.propertyDocumentID) {
            propertyDocumentID = bookings[currentIndex].propertyDocumentID;
          }
        }

        if (!propertyDocumentID) {
          setLoading(false);
          return;
        }

        const token = localStorage.getItem('token');

        const response = await fetch(
          `${config.apiBaseUrl}/guest/upsale/property/${propertyDocumentID}/categories`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) throw new Error('Failed to fetch top picks');
        const data = await response.json();
        if (data.categories) setTopPicks(data.categories);
      } catch (err) {
        console.error('Error fetching top picks:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTopPicks();
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '400px',
        margin: '0 auto',
        position: 'relative',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 3,
          mt: 1,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: '#000',
            fontSize: '20px',
          }}
        >
          Top picks for you
        </Typography>
      </Box>

      {/* Content */}
      <Container
        maxWidth="sm"
        sx={{
          flex: 1,
          px: 3,
          pb: 12,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {loading
            ? Array.from({ length: 3 }).map((_, idx) => (
                <Box key={idx}>
                  <Skeleton variant="text" width="50%" height={24} sx={{ mb: 1 }} />
                  <Skeleton variant="text" width="80%" height={18} sx={{ mb: 2 }} />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={200}
                    sx={{ borderRadius: '16px' }}
                  />
                </Box>
              ))
            : topPicks.map((item) => (
                <Box
                  key={item._id}
                  onClick={() => navigate(`/category/${item._id}`)}
                  sx={{ cursor: 'pointer' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        fontSize: '18px',
                        color: '#000',
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#666',
                        fontSize: '14px',
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      borderRadius: '16px',
                      overflow: 'hidden',
                      height: '200px',
                      backgroundColor: '#eee',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Box
                      component="img"
                      src={item.image}
                      alt={item.name}
                      sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </Box>
                </Box>
              ))}
        </Box>
      </Container>

      <BottomNavigation />
    </Box>
  );
}
